import { createStyles, makeStyles } from '@material-ui/core';
import { DRAWER_WIDTH } from '../services/constants';

const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            padding: 4
        },
        drawerPaper: {
            backgroundColor: theme.palette.grey['600'],

            width: DRAWER_WIDTH,
            // float:'left',
            position: 'static',
            borderRight: 0,

            height: theme.sizes.pageHeight
        },
        indicatorWrapper: { display: 'flex', alignItems: 'center' },
        headlineWrapper: { display: 'flex', alignItems: 'center', transform: 'translate(-16px)' },
        drawer: {
            backgroundColor: theme.palette.grey['600'],
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(2),
            // backgroundColor: '#000',
            position: 'sticky',

            top: theme.mixins.toolbar.minHeight,
            alignSelf: 'baseline',
            [theme.breakpoints.up('sm')]: {
                width: DRAWER_WIDTH
            }
        },
        toolbar: theme.mixins.toolbar,
        url: {
            color: '#ccc'
        },
        drawerText: {},
        drawerTitle: {
            position: 'sticky',
            paddingTop: 10,
            top: -10,
            zIndex: 10,
            backgroundColor: theme.palette.grey['600'],
            color: theme.palette.primary.light,
            borderBottom: `1px solid ${theme.palette.primary.light}`,
            marginBottom: theme.spacing(4)
        },
        indicator: {
            width: 12,
            height: 12,
            marginRight: 8,
            borderRadius: '99em',
            float: 'left',
            backgroundColor: theme.palette.primary.light,
            opacity: 0
        },
        hide: {
            opacity: 1
        }
    })
);

export default useStyles;
